module.exports = __webpack_public_path__ + "img/img-2-2mobile.2b11391f.webp";